<template>
  <article class="list-card">
    <header class="card-header">
      <h3 class="card-title">{{ title || 'Comments' }}</h3>
    </header>

    <div class="card-body">
      <div v-if="loading" class="list-scroll duallo-scroll">
        <div v-for="n in 3" :key="n" class="sk-item">
          <div class="sk sk-thumb"></div>
          <div class="sk-content">
            <span class="sk sk-line" style="width: 80%"></span>
            <span class="sk sk-line" style="width: 50%; height: 0.7rem"></span>
          </div>
        </div>
      </div>

      <div v-else-if="comments.length > 0" class="list-scroll duallo-scroll">
        <DashboardListItem v-for="item in comments" :key="item.id" :item="item" />
      </div>

      <div v-else class="list-empty">
        <v-icon size="32" color="#4a5a60">mdi-comment-text-outline</v-icon>
        <span>No comments available</span>
      </div>
    </div>
  </article>
</template>

<script>
import DashboardListItem from '../list-items/DashboardListItem.vue';

export default {
  name: 'DashboardListComponent',
  components: { DashboardListItem },
  props: {
    title: { type: String, default: "" },
    dataFetcher: { type: Function, default: null }
  },
  data() {
    return { comments: [], loading: true };
  },
  async mounted() {
    this.loading = true;
    try {
      if (this.dataFetcher != null) {
        this.comments = await this.dataFetcher();
      }
    } catch (error) {
      console.error(`Error fetching data for ${this.title}`, error);
    } finally {
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.list-card {
  background: var(--duallo-card-gradient);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  color: #fff;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.card-header {
  padding: 16px 18px 8px;
}

.card-title {
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
  color: #ffffff;
  letter-spacing: 0.01em;
}

.card-body {
  flex: 1 1 auto;
  min-height: 0;
  padding: 4px 14px 14px;
  display: flex;
  flex-direction: column;
}

.list-scroll {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1 auto;
  min-height: 0;
  padding-right: 6px;
}

.list-empty {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 32px 16px;
  color: #8aa0aa;
  font-size: 0.9rem;
}

/* Loading shimmer rows */
.sk-item {
  display: flex;
  align-items: stretch;
  flex: 0 0 auto;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  overflow: hidden;
}
.sk-content {
  flex: 1 1 auto;
  min-width: 0;
  padding: 12px 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}
.sk {
  position: relative;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}
.sk-thumb { flex: 0 0 52px; width: 52px; align-self: stretch; min-height: 52px; border-radius: 0; }
.sk-line { display: block; height: 0.9rem; }
.sk::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.09), transparent);
  animation: sk-shimmer 1.25s ease-in-out infinite;
}
@keyframes sk-shimmer { 100% { transform: translateX(100%); } }
@media (prefers-reduced-motion: reduce) {
  .sk::after { animation: none; }
}
</style>
